import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M455.019 365.171c-84.117 145.043-293.712 144.633-377.278-.744-83.554-145.376 21.602-326.68 189.286-326.36a217.83 217.83 0 0 1 165.954 77.25H330.477v25.626h128.13c7.086 0 12.813-5.74 12.813-12.813V0h-25.626v91.741C319.086-46.332 90.413 4.549 34.202 183.316-22.022 362.095 136.373 534.687 319.304 493.98a243.42 243.42 0 0 0 158.01-115.996z" }, null, -1),
    _createElementVNode("path", { d: "M252.061 154.781v102.504a12.86 12.86 0 0 0 3.716 9.097l51.252 51.252 18.067-18.066-47.409-47.536v-97.251z" }, null, -1)
  ])))
}
export default { render: render }